<script>
  import CallToActionBlock from '@/components/FlexibleContent/CallToActionBlock'
  import LinkBlock from './LinkBlock.vue';

  export default {
    name: 'CallToActionBlocks',
    components: {
      CallToActionBlock,
      LinkBlock
    },
    props: {
      data: {
        type: Object,
        default: () => ({}),
        required: true
      }
    },
    data () {
      return {
        componentsMap: [
          {
            name: 'callToAction',
            component: CallToActionBlock
          },
          {
            name: 'linkCard',
            component: LinkBlock
          }
        ]
      }
    },
    methods: {
      componentLoader (component) {
        const componentName = component.sys.contentType.sys.id
        const matched = this.componentsMap.find(entry => entry.name === componentName)
        return matched ? matched.component : false
      }
    }
  }
</script>

<template>
  <div class="container relative px-4 md:px-8">
    <div class="w-full mx-auto md:mt-12 md:mb-16">
      <div
        v-if="data.fields.block"
        class="call-to-action-blocks"
      >
        <div
          v-for="(component, i) in data.fields.block"
          :key="i"
          class="w-full md:px-5 md:pb-10"
        >
          <component
            :is="componentLoader(component)"
            :fields="component.fields"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.call-to-action-blocks {
  @apply grid grid-cols-1 md:grid-cols-2 gap-4 justify-items-stretch;
}
</style>
